var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileRigthArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1917 0.98959L22.601 6.39896C22.933 6.7309 22.933 7.26909 22.601 7.60104L17.1917 13.0104C16.8597 13.3424 16.3215 13.3424 15.9896 13.0104C15.6576 12.6785 15.6576 12.1403 15.9896 11.8083L19.9479 7.85H0V6.15H19.9479L15.9896 2.19167C15.6576 1.85973 15.6576 1.32154 15.9896 0.98959C16.3215 0.657645 16.8597 0.657645 17.1917 0.98959Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRigthArr);
export default __webpack_public_path__ + "static/media/MobileRigthArr.ff26788f.svg";
export { ForwardRef as ReactComponent };